import { Route, RouteSectionProps, Router } from '@solidjs/router'
import { AlertFnd } from 'comps'
import { Navbar } from 'layout/navbar'
import Home from 'pages/home'
import { Login } from 'pages/login'
import { self } from 'store'

import { Component, Show, lazy } from 'solid-js'
import { render } from 'solid-js/web'

import './preload'
import './style/font/imports.scss'
import './style/index.scss'

const Root = () => {
    return (
        <>
            <Show when={!self.loading} fallback='Loading ...'>
                <Show when={self.loged_in} fallback={<Login />}>
                    <Routes />
                </Show>
            </Show>
            <AlertFnd />
        </>
    )
}

const Dash: Component<RouteSectionProps> = P => {
    return (
        <div class='dash'>
            <Navbar />
            {P.children}
        </div>
    )
}

const Routes = () => {
    return (
        <Router>
            <Route path='/' component={Dash}>
                <Route path='/' component={Home} />
                <Route
                    path='/wheats/'
                    component={lazy(() => import('pages/wheats'))}
                />
                <Route
                    path='/wheat-kernel/'
                    component={lazy(() => import('pages/wheat_kernel'))}
                />
                <Route
                    path='/farmers/'
                    component={lazy(() => import('pages/farmers'))}
                />
                <Route
                    path='/plugin/'
                    component={lazy(() => import('pages/plugin'))}
                />
                <Route
                    path='/kernel-state/'
                    component={lazy(() => import('pages/kernel-state'))}
                />
                <Route
                    path='/tasks/'
                    component={lazy(() => import('pages/tasks'))}
                />
            </Route>
            <Route path='*path' component={() => 'not found ...'} />
        </Router>
    )
}

render(Root, document.getElementById('root')!)
